<template>
  <div class="container league-table">
    <!-- 赛事分类 -->
    <div class="header">
      <img src="../../assets/img/logo.png" alt="中国保龄球协会" />
    </div>
    <!-- 历史积分榜区域 -->
    <div class="historyBox">
      <van-button
        class="historyScoreBtn"
        size="mini"
        round
        type="warning"
        @click="show = !show"
        >历史积分</van-button
      >
      <van-button
        class="scoreGruidBtn"
        size="mini"
        round
        type="warning"
        @click="showGruid = !showGruid"
        >积分说明</van-button
      >
      <van-popup class="showPopup" v-model:show="show" position="right">
        <div class="title">巡回赛历史积分</div>
        <div v-for="(item, idx) in historyList" class="fileBox">
          <div>
            <a :key="idx" @click="goPDFFun(item)">{{ item.name }}</a>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- 类型分类tab -->
    <div class="tab-bar">
      <el-tabs v-model="type" @tab-click="handleClick" type="border-card">
        <el-tab-pane label="巡回赛积分榜" name="1">
          <div class="tab-bar-item">
            <template v-for="(item, idx) in xhsTabList" :key="item">
              <van-button
                v-if="item.length > 0"
                size="mini"
                :type="tourChampionship == idx ? 'primary' : 'default'"
                :plain="tourChampionship != idx ? true : false"
                @click="handleChangeBtn(idx, 'tourChampionship')"
                >{{ item }}</van-button
              >
            </template>
          </div></el-tab-pane
        >

        <el-tab-pane label="协会积分榜" name="0">
          <div class="tab-bar-item">
            <template v-for="(item, idx) in xhTabList" :key="item">
              <van-button
                size="mini"
                :type="association == idx ? 'primary' : 'default'"
                :plain="association != idx ? true : false"
                @click="handleChangeBtn(idx, 'association')"
                >{{ item }}</van-button
              >
            </template>
          </div></el-tab-pane
        >

        <el-tab-pane label="青少年积分榜" name="2">
          <div class="tab-bar-item">
            <template v-for="(item, idx) in qsnTabList" :key="idx">
              <van-button
                size="mini"
                :type="gender == idx ? 'primary' : 'default'"
                :plain="gender != idx ? true : false"
                @click="handleChangeBtn(idx, 'gender')"
                >{{ item }}</van-button
              >
            </template>
          </div>
          <div class="tab-bar-item">
            <template v-for="(item, idx) in qsnSedTabList" :key="idx">
              <van-button
                size="mini"
                :type="championship == idx ? 'primary' : 'default'"
                :plain="championship != idx ? true : false"
                @click="handleChangeBtn(idx, 'championship')"
                >{{ item }}</van-button
              >
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 数据列表 -->
    <div class="data-list">
      <div style="margin-bottom: 10px">
        <el-input
          placeholder="请输入姓名"
          :prefix-icon="Search"
          v-model="searchName"
        ></el-input>
      </div>
      <el-table
        v-loading="loading"
        :data="handleSearchName"
        style="width: 100%"
        :cell-style="{ padding: '0px!important', margin: '0px' }"
        size="small"
        :default-sort="{ prop: 'ranking', order: 'ascending' }"
      >
        <template v-for="item in handleTableColumns" :key="item.prop">
          <el-table-column
            v-if="item.dynamicColumns.length == 0"
            :prop="item.key"
            :fixed="
              ['ranking', 'playerName'].indexOf(item.key) != -1 ? true : false
            "
            :label="item.displayName"
            :width="handleTableWidth(item.key, dataList)"
            :class-name="item.key"
          >
          </el-table-column>
          <template
            v-else
            v-for="(item1, idx) in item.dynamicColumns"
            :key="idx"
          >
            <el-table-column :label="item1" class-name="stage-scores">
              <template #default="scope">
                {{ scope.row.stageScores[idx].score }}
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
      <div
        v-if="showMore && !loading"
        @click="handlePage"
        style="text-align: center; font-size: 0.5rem; color: aquamarine"
      >
        <el-button>加载更多</el-button>
      </div>
      <div
        v-else-if="!showMore"
        style="text-align: center; font-size: 0.5rem; color: aquamarine"
      >
        <el-button type="warning">没有更多数据了</el-button>
      </div>
    </div>
    <!-- 积分说明 -->
    <van-overlay
      z-index="100000"
      class="gruidBox"
      :show="showGruid"
      @click="showGruid = false"
    >
      <div class="wrapper">
        <div class="block">
          <P>
            1、巡回赛积分：正赛结束后，将所有运动员成绩按照飞碟，弧线进行分组。分别排名，按照名次进行积分。进入前八名的有额外的加分。根据飞狐对抗赛名次，前八名分别进行积分，所得积分为对应正赛名次积分的10%；出现同分时，根据竞赛规程进行名次区分。如果按照竞赛规程无法区分名次，必须按照同名次处理，则2人积分为对应2个积分之和除2，如并列第3和第4
            ，第三名积分300，第四名积分200，则并列第三，2人积分250分。</P
          >
          <P
            >2、协会积分：正赛结束后，将所有运动员按照性别进行分组。分别排名，按照名次进行积分。前八名无额外加分。</P
          >
          <P>3、锦标赛及公开赛中，精英赛及对抗赛不再额外计算积分。</P>
          <P
            >4、青少年按照U13（小学），U16（初中），U19（高中），U22（大学）；4个组别分别计算积分。根据运动员报名时选择的组别进行积分。不按照年龄计算积分。</P
          >
          <P
            >5、团体项目按照队伍名次进行积分，积分后按照人数进行平均。如双人赛第1名积1000分，每个人平均为500，依次类推，如果是5人队际，有额多，并且2节之间换人，则总积分除以6为每个人的积分。</P
          >
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { createState } from "../../store";
import request from "../../utils/request";
import { Search } from "@element-plus/icons-vue";
export default {
  setup() {
    const data = reactive(createState);
    const xhTabList = [
      "男子积分榜（总分）",
      "女子积分榜（总分）",
      "男子积分榜（平均分）",
      "女子积分榜（平均分）",
    ];
    const xhsTabList = ["总积分榜", "", "", "奖金榜"];
    const qsnTabList = ["男子", "女子"];
    const qsnSedTabList = ["U13", "U16", "U19", "U22"];
    const tableWidthCfg = {
      ranking: "40rem",
      playerName: "60rem",
      gender: "40rem",
      Association: "120rem",
      clubs: "150rem",
      numbers: "40rem",
      playing: "40rem",
      totalScore: "80rem",
      "stage-scores": "160rem",
    };
    const historyList = ref([
      {
        name: "2025年中国保龄球巡回赛积分排名",
        fileUrl: "2025年中国保龄球巡回赛积分排名.pdf",
      },
      {
        name: "2024年中国保龄球巡回赛（弧线）积分排名",
        fileUrl: "2024年中国保龄球巡回赛（弧线）积分排名.pdf",
      },
      {
        name: "2024年中国保龄球巡回赛（飞碟）积分排名",
        fileUrl: "2024年中国保龄球巡回赛（飞碟）积分排名.pdf",
      },
      {
        name: "2023年中国保龄球巡回赛积分总排行",
        fileUrl: "2023年中国保龄球巡回赛积分总排行.pdf",
      },
      {
        name: "2023年中国保龄球巡回赛奖金总排行",
        fileUrl: "2023年中国保龄球巡回赛奖金总排行.pdf",
      },
      {
        name: "2023年中国保龄球巡回赛（弧线）积分排行",
        fileUrl: "2023年中国保龄球巡回赛（弧线）积分排行.pdf",
      },
      {
        name: "2023年中国保龄球巡回赛（飞碟）积分排行",
        fileUrl: "2023年中国保龄球巡回赛（飞碟）积分排行.pdf",
      },
    ]);
    const show = ref(false);
    const showGruid = ref(false);
    return {
      state: reactive(createState),
      type: ref("1"),
      association: ref(0),
      tourChampionship: ref(0),
      gender: ref(0),
      championship: ref(0),
      xhsTabList,
      xhTabList,
      qsnTabList,
      qsnSedTabList,
      dataList: ref([]),
      tableColumns: ref([]),
      tableWidthCfg: tableWidthCfg,
      loading: false,
      searchName: ref(""),
      show,
      showGruid,
      historyList,
      pageSize: ref(50),
      pageIndex: ref(1),
      totalNum: ref(0),
      showMore: ref(true),
      Search,
    };
  },
  props: {},
  methods: {
    // tab切换时更改active参数，请求数据
    handleClick(e, event) {
      this.type = e.props.name;
      this.pageIndex = 1;
      this.showMore = true;
      this.getData();
    },
    // 处理翻页
    handlePage() {
      if (this.pageIndex <= this.totalNum / this.pageSize) {
        this.showMore = true;
        this.pageIndex++;
      } else {
        this.showMore = false;
        this.$message.warning("没有更多数据了");
      }
    },
    // 切换按钮时更改参数，请求数据
    handleChangeBtn(idx, e) {
      if (idx == this[e]) {
        return;
      }
      this[e] = idx;
      this.pageIndex = 1;
      this.showMore = true;
      this.getData();
    },
    // 根据key 返回列的宽度
    handleTableWidth(key, list) {
      if (key == "stage-scores") {
        return this.tableWidthCfg[key] || 100;
      } else {
        let maxByteLength = 55;
        list.forEach((element) => {
          maxByteLength = Math.max(
            Buffer.byteLength(element[key], "utf8") * 5,
            maxByteLength,
          );
        });
        return maxByteLength + "rem";
      }
    },
    // 获取数据
    getData() {
      this.dataList = [];
      this.loading = true;
      request({
        url: "/Point/GetMatchPoints",
        method: "post",
        data: {
          type: Number(this.type),
          tourChampionship: this.tourChampionship,
          gender: this.gender,
          gender: this.gender,
          championship: this.championship,
          association: this.association,
        },
      })
        .then((data) => {
          this.tableColumns =
            data.resultValue.dataList.projectInfo.tableColumns;
          this.dataList = data.resultValue.dataList.pointDataList;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    // 打开pdf
    goPDFFun(data) {
      if (data.fileUrl.split(".")[1] != "pdf") {
        location.href = data.fileUrl;
        window.open(data.fileUrl, "_blank");
      } else {
        this.$router.push({ name: "pdf", query: { url: data.fileUrl } });
      }
    },
  },
  mounted() {},
  created() {
    this.getData();
  },
  computed: {
    // 处理列显示与否
    handleTableColumns() {
      return this.tableColumns.filter((item) => {
        return item.isShow == 0;
      });
    },
    // 动态搜索姓名
    handleSearchName() {
      let handleDataList = this.searchName
        ? this.dataList.filter((item) => {
            return item.playerName.indexOf(this.searchName) != -1;
          })
        : this.dataList;
      this.totalNum = handleDataList.length;
      return handleDataList.slice(
        0,
        Math.min(this.pageSize * this.pageIndex, handleDataList.length),
      );
    },
    //
  },
};
</script>
<style>
#comNoticeBar {
  /* 不显示提示滚动条 */
  display: none !important;
  .cell {
    padding: 0 !important;
  }
  thead {
    /* background: red !important; */
  }
}
</style>
<style lang="less" scoped>
.league-table {
  .historyBox {
    .historyScoreBtn {
      position: absolute;
      padding: 0 8px;
      right: -8px;
      top: 120px;
      z-index: 100;
    }
    .scoreGruidBtn {
      position: absolute;
      padding: 0 8px;
      right: -8px;
      top: 80px;
      z-index: 100;
    }
    .title {
      text-align: center;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      font-weight: 600;
    }
    .fileBox {
      padding: 8px 4px;
      background: white;
      color: #409eff;
      font-size: 14px;
      border-bottom: 2px solid rgba(0, 0, 0, 0.1);
      a {
        color: #409eff;
      }
    }
  }
  .header {
    img {
      height: 100%;
    }
    height: 50px;
    padding: 5px;
    text-align: center;
  }
  .tab-bar-item {
    padding: 5px;
  }
  .data-list {
    padding: 12px;
  }
  /deep/.showPopup {
    width: 70%;
    height: 100%;
    background: #f7f8fa;
    .propBox {
      width: 100%;
      height: 1rem;
      border-bottom: 1px solid #eee;
      line-height: 1rem;
      .matchTypeName {
        width: 90%;
        float: left;
        text-indent: 6px;
        font-size: 0.36rem;
        font-weight: 700;
      }
    }
  }
  .gruidBox {
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .block {
      padding: 10px;
      width: 80vw;
      max-height: 90vh;
      overflow: auto;
      background-color: #fff;
      p {
        margin: 5px 0;
        font-size: 0.25rem;
      }
    }
  }
}
</style>
